// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__NfWoY","inputWrap":"styles_inputWrap__3Rhi8","input":"styles_input__1i4Nv"};